import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { TaskStatusResponse } from '../models/task.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface TaskStatusDrawerOptions { statusId?: number; }

@Injectable({ providedIn: 'root' })
export class TaskStatusDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: TaskStatusDrawerOptions }>({
    isOpen: false, options: {}
  });
  private readonly saved$$ = new Subject<TaskStatusResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: TaskStatusDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }
  notifySaved(item: TaskStatusResponse): void { this.saved$$.next(item); }
}
